export const getStoreTitleDetails = (i18n, storesData, storeContainerData = {}, isAudience = false) => {
  const storeId = storeContainerData.ProviderId;
  if (!storeId) {
    return i18n.getString(_TL_('No store added'));
  }
  const { countries, stores } = storesData;
  const store =
    (stores[storeId] && stores[storeId].text) ||
    `ID: ${storeId}`; // Display only Store ID while stores are loading. No localization to be consistent with how we display stores.
  const salesCountry =
    (countries[storeContainerData.SalesCountry] && countries[storeContainerData.SalesCountry].text)
    || storeContainerData.SalesCountry;
  const localInventoryAdsEnabled = storeContainerData.LocalInventoryAdsEnabled ?
    i18n.getString(_TL_('Enabled')) :
    i18n.getString(_TL_('Disabled'));

  if (isAudience) {
    return i18n.getString(_TL_('Merchant Center store: {{store}}. Country/region of sale: {{salesCountry}}'), {
      store, salesCountry,
    });
  }
  return i18n.getString(_TL_('Merchant Center store: {{store}}. Country/region of sale: {{salesCountry}}. Local inventory ads: {{localInventoryAdsEnabled}}'), {
    store, salesCountry, localInventoryAdsEnabled,
  });
};
